// import React from "react";
// import "./Publication.css";
// import publicationImage from "../images/publication.jpg";

// const categories = [
//   "दिवाळी अंक",
//   "ऐतिहासिक",
//   "धार्मिक",
//   "अध्यात्मिक",
//   "कथा-कादंबरी",
//   "कविता संग्रह",
//   "आत्मचरित्र",
//   "दुर्मिळ हस्तलिखिते",
//   "दुर्मिळ ग्रंथ",
//   "बालविभाग",
//   "महिला विभाग",
//   "स्पर्धा परीक्षा",
//   "विनोदी साहित्य",
//   "सर्व प्रकारचे धार्मिक ग्रंथ",
// ];

// export default function Publications() {
//   return (
//     <div className="publications-container">
//       <div className="publications-card">
//         <h1 className="publications-heading">“प्रकाशने”</h1>

//         {/* ✅ Image + Text Side by Side */}
//         <div className="content-row">
//           <div className="image-wrapper">
//             <img
//               src={publicationImage}
//               alt="प्रकाशने"
//               className="publication-image"
//             />
//           </div>

//           <div className="text-content">
//            <p className="library-info">
//           आमच्या ग्रंथालयामध्ये विविध विषयांवरील समृद्ध आणि दर्जेदार साहित्य उपलब्ध आहे.
//           वाचकांच्या सर्व वयोगटांसाठी तसेच विविध आवडी-निवडी लक्षात घेऊन पुस्तके
//           आणि विशेष अंक उपलब्ध करून देण्यात आले आहेत. ज्ञान, संस्कार आणि
//           मनोरंजन यांचा सुंदर संगम आमच्या प्रकाशनांमध्ये अनुभवायला मिळतो.
//         </p>

//            <p className="library-info">
//           अभ्यासक, संशोधक तसेच स्पर्धा परीक्षेची तयारी करणाऱ्या विद्यार्थ्यांसाठी
//           विशेष संदर्भग्रंथ आणि अद्ययावत साहित्य उपलब्ध आहे. पारंपरिक आणि
//           आधुनिक विचारांचा संगम असलेली पुस्तके वाचकांना नवे ज्ञान देण्यास मदत करतात.
//         </p>

//             <p className="library-info">
//           आमचे उद्दिष्ट वाचनसंस्कृतीला प्रोत्साहन देणे आणि समाजात ज्ञानाचा प्रसार
//           करणे हे आहे. विविध विषयांवरील दुर्मिळ ग्रंथ आणि हस्तलिखिते
//           वाचकांसाठी खास जतन करून ठेवण्यात आलेली आहेत.
//         </p>
//           </div>
//         </div>

//         <div className="categories-section">
//           <h2>उपलब्ध वाचन प्रकार</h2>
//           <div className="categories-grid">
//             {categories.map((item, index) => (
//               <div key={index} className="category-card">
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }







import React from "react";
import "./Publication.css";

const categories = [
  "दिवाळी अंक",
  "ऐतिहासिक",
  "धार्मिक",
  "अध्यात्मिक",
  "कथा-कादंबरी",
  "कविता संग्रह",
  "आत्मचरित्र",
  "दुर्मिळ हस्तलिखिते",
  "दुर्मिळ ग्रंथ",
  "बालविभाग",
  "महिला विभाग",
  "स्पर्धा परीक्षा",
  "विनोदी साहित्य",
  "सर्व प्रकारचे धार्मिक ग्रंथ",
];

export default function Publications() {
  return (
    <div className="publications-container">
      <div className="publications-card">
        <h1 className="publications-heading">“प्रकाशने”</h1>

        {/* ✅ टेक्स्ट कॉन्टेंट आता मुख्य हायलाईट होईल */}
        <div className="content-row">
          <div className="text-content">
            <p className="library-info">
              आमच्या ग्रंथालयामध्ये विविध विषयांवरील समृद्ध आणि दर्जेदार साहित्य उपलब्ध आहे.
              वाचकवर्गाच्या सर्व वयोगटांसाठी तसेच विविध आवडी-निवडी लक्षात घेऊन पुस्तके
              आणि विशेष अंक उपलब्ध करून देण्यात आले आहेत. ज्ञान, संस्कार आणि
              मनोरंजन यांचा सुंदर संगम आमच्या प्रकाशनांमध्ये अनुभवायला मिळतो.
            </p>

            <p className="library-info">
              अभ्यासक, संशोधक तसेच स्पर्धा परीक्षेची तयारी करणाऱ्या विद्यार्थ्यांसाठी
              विशेष संदर्भग्रंथ आणि अद्ययावत साहित्य उपलब्ध आहे. पारंपरिक आणि
              आधुनिक विचारांचा संगम असलेली पुस्तके वाचकांना नवे ज्ञान देण्यास मदत करतात.
            </p>

            <p className="library-info">
              आमचे उद्दिष्ट वाचनसंस्कृतीला प्रोत्साहन देणे आणि समाजात ज्ञानाचा प्रसार
              करणे हे आहे. विविध विषयांवरील दुर्मिळ ग्रंथ आणि हस्तलिखिते
              वाचकांसाठी खास जतन करून ठेवण्यात आलेली आहेत.
            </p>
          </div>
        </div>

        {/* ✅ कॅटेगरी सेक्शन */}
        <div className="categories-section">
          <h2>उपलब्ध वाचन प्रकार</h2>
          <div className="categories-grid">
            {categories.map((item, index) => (
              <div 
                key={index} 
                className="category-card"
                style={{ animationDelay: `${index * 0.05}s` }} // एकामागून एक येणारे सुंदर कार्ड ॲनिमेशन
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}